<template>
  <b-card>
    <p v-if="errorMsg">
      <code class="mb-2" color="danger">
      {{ $t(errorMsg) }}
      </code>
    </p>
    <a>{{ $t('Please enter your new phone number. You have to enter your password to verify you are doing this action.') }}</a>
    <p>{{ $t('We will send you a confirmation code via the new phone number.') }}</p>
    <div v-if="step === 'requestOTP'">
      <validation-observer
        ref="changePhoneForm"
        #default="{invalid}"
        v-if="step === 'requestOTP'"
      >
      <b-form>
        <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="phone">{{ $t("New phone number") }}</label>
                <input
                  ref="phoneInput"
                  class="form-control"
                  id="phone"
                  @input="validatePhoneNumber"
                  type="number"
                  onkeypress='return event.charCode !== 46 && event.charCode !== 43 && event.charCode !== 45'
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="password">{{ $t("Password") }}</label>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                  ref="passwordInput"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="password"
                      :placeholder=" $t('Type your password')"
                      @keyup.enter="requestOTP"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-button
                  :disabled="invalid || !isValidNumber || isloading"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="requestOTP"
                >
                  <b-spinner small v-if="isloading"/>
                  {{ $t('Request OTP') }}
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
      </b-form>
      </validation-observer>
    </div>
    <div v-if="step === 'verifyOTP'">
      <b-form>
        <b-card-text class="mb-2">
          {{ $t("Enter 6 digits verification code sent to your new phone number") }}
        </b-card-text>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <v-otp-input
                  v-model="otp"
                  ref="otpInput"
                  input-classes="otp-input"
                  separator=" "
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOnChange"
                  @on-complete="handleOnComplete"
                  v-on:keyup.native.enter="verifyOTP"
                />
                <br>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-button
                  :disabled='isDisabled'
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="verifyOTP"
                >
                  <b-spinner small v-if="isloading"/>
                  {{ $t('Verify') }}
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
    </div>
  </b-card>
</template>
<script>
  import {
    ValidationProvider,
    ValidationObserver,
  } from 'vee-validate/dist/vee-validate.full';
  import {
    BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BLink, BInputGroup, BInputGroupAppend, BSpinner,
  } from 'bootstrap-vue'
  import VueSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import Apicall from '@/libs/api-call'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import VOtpInput from "@bachdgvn/vue-otp-input";
  import { togglePasswordVisibility } from '@core/mixins/ui/forms'
  // import International Telephone Input
  import intlTelInput from '@/libs/intl-tel-input/js/intlTelInput.js';
  import utilsScript from '@/libs/intl-tel-input/js/utils.js'
  import '@/libs/intl-tel-input//css/intlTelInput.css';

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BLink,
    VueSelect,
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
    VOtpInput,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  data() {
    return {
      password: null,
      passwordFieldType: 'password',
      newPhoneNumber: null,
      geoinfos: {},
      step: 'requestOTP',
      errorMsg: null,
      isloading: false,
      otp: null,
      fastconnectToken: null,
      isDisabled: true,
      cellContainer: {},
      isValidNumber: false,
    }
  },
  mounted() {
    this.getGeoInfo();
  },
  methods: {
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    getGeoInfo() {
      if (Object.keys(this.$store.state.geoinfos).length === 0) {
        this.$http.get('https://gapps.soustitreur.com/').then(res => {
          this.$store.state.geoinfos = res.data;
          this.geoinfos= this.$store.state.geoinfos;
          this.generatePhoneNumber();
        })
      } else {
        this.geoinfos= this.$store.state.geoinfos;
        this.generatePhoneNumber();
      }
    },
    requestOTP() {
      this.$refs.passwordInput.validate().then(result => {
        if (result.valid && this.isValidNumber && this.isloading === false) {
          if (this.newPhoneNumber[0] === '+') {
            this.newPhoneNumber = this.newPhoneNumber.substring(1);
          }
          const api = new Apicall();
          this.isloading = true;
          api.requestOTPChangeEmailPhone('phoneNumber', null, this.newPhoneNumber, this.password, this.$i18n.locale, this.geoinfos).then((response) => {
              if (response.status === 'OK') {
                this.step = 'verifyOTP';
                this.fastconnectToken = response.data.data.token;
                this.errorMsg = null;
              } else {
                if (response.statuscode === 401) this.$router.push('Login').then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: this.$t(response.msg),
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  });
                });
                this.errorMsg = this.$t(response.msg);
              }
              this.isloading = false;
          }).catch((response) => {
            this.isloading = false;
            this.errorMsg = this.$t(response.msg);
          });
        }
      });
    },
    handleOnChange(value) {
      if (value.length === 6) {
        this.otp = value;
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    handleOnComplete(value) {
        this.otp = value;
        this.isDisabled = false;
    },
    verifyOTP() {
      if (this.otp.length === 6) {
        const api = new Apicall();
        this.isloading = true;
        api.verifyOTPChangeEmailPhone('phoneNumber', this.fastconnectToken, this.otp).then((response) => {
            if (response.status === 'OK') {
              this.errorMsg = null;
              this.$router.push({name:'UserAccountSetting'})
                  .then(() => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        variant: 'success',
                        title: this.$t('Changed phone number successfully!'),
                        icon: 'CheckIcon'
                      },
                    });
                });
            } else {
              if (response.statuscode === 401) this.$router.push('Login').then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t(response.msg),
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                });
              });
              this.errorMsg = this.$t(response.msg);
            }
            this.isloading = false;
        }).catch((response) => {
          this.isloading = false;
          this.errorMsg = this.$t(response.msg);
        });
      }
    },
    generatePhoneNumber() {
      const input = document.querySelector("#phone");
      var countryCode = "ca";
      if(this.geoinfos){
          countryCode = this.geoinfos.COUNTRY ? this.geoinfos.COUNTRY.toLowerCase() : "ca";
      }
      this.cellContainer = intlTelInput(input, {
        utilsScript: utilsScript,
        autoPlaceholder: "aggressive",
        separateDialCode: true,
        preferredCountries: ['fr','ca','be','us','mx'],
        initialCountry: "auto",
        geoIpLookup: function(success, failure){
            success(countryCode);
        },
      });
    },
    validatePhoneNumber() {
      if (typeof this.cellContainer.selectedCountryData.dialCode === 'undefined') {
        this.newPhoneNumber = this.cellContainer.telInput.value.trim();
        if (this.cellContainer.telInput.value.trim().match(/^514|^418|^438|^581|^819|^579/) !== null) {
          this.cellContainer.selectedCountryData = this.cellContainer._getCountryData('ca', false, false);
          this.cellContainer._setFlag('ca');
          this.newPhoneNumber = this.cellContainer.selectedCountryData.dialCode.concat(this.cellContainer.telInput.value.trim());
        }
      } else {
        this.newPhoneNumber = this.cellContainer.selectedCountryData.dialCode.concat(this.cellContainer.telInput.value.trim());
      }
      if (this.cellContainer.isValidNumber()) {
        this.isValidNumber = true;
        this.$refs.phoneInput.classList.remove("is-invalid");
      } else {
        this.isValidNumber = false;
        this.$refs.phoneInput.classList.add("is-invalid");
      }
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.fullscreen {
  background-image: linear-gradient(90deg, #b6fdb2 0%, #b6fdb2 50%, #EBFFEB 100%);
}
html[dir=ltr] .content {
    margin-left: 0px;
}
.otp-input {
  width: 36px;
  height: 36px;
  padding: 5px;
  margin: 0 2px;
  font-size: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

